import { render, staticRenderFns } from "./spaceRequestsPreview.vue?vue&type=template&id=99dd6f60&scoped=true&"
import script from "./spaceRequestsPreview.vue?vue&type=script&lang=js&"
export * from "./spaceRequestsPreview.vue?vue&type=script&lang=js&"
import style0 from "./spaceRequestsPreview.vue?vue&type=style&index=0&id=99dd6f60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dd6f60",
  null
  
)

export default component.exports